import React from 'react';
import cn from 'classnames';
import { AccordionHeader } from './AccordionHeader';
import { AccordionPanel } from './AccordionPanel';
export const AccordionItem = React.forwardRef(({ title, subtitle, children, open, headerId, panelId, panelOverlay, className }, ref) => (React.createElement("div", { className: cn('cb-accordion-container', panelOverlay && 'cb-accordion-panel-overflow', className), ref: ref },
    React.createElement(AccordionHeader, { title: title, subtitle: subtitle, headerId: headerId }),
    React.createElement(AccordionPanel, { open: open, panelId: panelId }, children))));
//# sourceMappingURL=AccordionItem.js.map